import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/axiosInstance";
import UpcomingCourses from "../../components/course/UpcomingCourses";
import UpcomingCoursesDelete from "../../components/course/UpcomingCoursesDelete";

const AddCourseTimeline = () => {
  const navigate = useNavigate();

  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");

  const [startDate, setStartDate] = useState("");
  const [duration, setDuration] = useState("");
  const [loading, setLoading] = useState(false);

  // 🔹 Fetch all courses
  useEffect(() => {
    api
      .get("/courses")
      .then((res) => setCourses(res.data))
      .catch((err) => console.error("Get courses error:", err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedCourse) {
      alert("Please select a course");
      return;
    }

    setLoading(true);

    try {
      await api.post(`/timeline/course/${selectedCourse}`, {
        startDate: startDate || null,
        duration: duration || null,
      });
    } catch (err) {
      console.error("Timeline error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
   <div className="max-w-xl mx-auto mt-10 bg-white text-gray-900 p-6 rounded-xl border border-green-200">
        
      <h2 className="text-2xl font-bold mb-6 text-green-800">
        Add Course Timeline
      </h2>
      <form onSubmit={handleSubmit} className="space-y-4">

        {/* Course Select */}
        <div>
          <label className="block text-gray-700 mb-1 font-medium">
            Select Course
          </label>
          <select
            value={selectedCourse}
            onChange={(e) => setSelectedCourse(e.target.value)}
            className="w-full p-2 rounded bg-white text-gray-900 border border-green-300 focus:border-green-500 focus:ring-2 focus:ring-green-200"
          >
            <option value="">-- Choose a course --</option>
            {courses.map((course) => (
              <option key={course.id} value={course.id}>
                {course.name}
              </option>
            ))}
          </select>
        </div>

        {/* Start Date */}
        <div>
          <label className="block text-gray-700 mb-1 font-medium">
            Start Date (optional)
          </label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="w-full p-2 rounded bg-white text-gray-900 border border-green-300 focus:border-green-500 focus:ring-2 focus:ring-green-200"
          />
        </div>

        {/* Duration */}
        <div>
          <label className="block text-gray-700 mb-1 font-medium">
            Duration (weeks – optional)
          </label>
          <input
            type="number"
            min="1"
            value={duration}
            onChange={(e) => setDuration(e.target.value)}
            className="w-full p-2 rounded bg-white text-gray-900 border border-green-300 focus:border-green-500 focus:ring-2 focus:ring-green-200"
          />
        </div>

        <button
          disabled={loading}
          className="w-full bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg font-medium transition-colors duration-200"
        >
          {loading ? "Saving..." : "Save Timeline"}
        </button>
      </form>
    </div>
    
    <UpcomingCoursesDelete/></> 
  );
};

export default AddCourseTimeline;